'use strict';

module.exports = require('./components/Modal');


//////////////////
// WEBPACK FOOTER
// ../~/react-modal-onfido/lib/index.js
// module id = 444
// module chunks = 1